import Stories from "../../components/stories/Stories"
import Posts from "../../components/posts/Posts"
import Share from "../../components/share/Share"
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from "react-router-dom";
import HoverComp from "../../components/hoverableImage/HoverableImage"
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import "./home.scss"

const Home = () => {
  return (
    <div className="home" style={{textAlign:"center"}}>
      
      {/* <Stories/>
      <Share/>
      <Posts/> */}

      {/* <Container md>
     
      <Row>
        
        <Col>
        <Link to="/information" relative="path" style={ {textDecoration: 'none',color:'black',textAlign:"center"} }>
        <HoverComp text={"INFORMATION"} img={"https://www.travelnuity.com/wp-content/uploads/2018/12/Pet-Passports.jpg"}/>
        </Link>
        </Col>
       
        <Col md >
<Link to="/forum" relative="path" style={ {textDecoration: 'none',color:'black',textAlign:"center"} }>
<HoverComp  text={"FORUM"} img={"https://static5.depositphotos.com/1006899/400/i/600/depositphotos_4000740-stock-photo-forum.jpg"} />
</Link>
</Col>
      
      </Row>
      <Row md>

<Col md>
<Link to="/search" relative="path" style={ {textDecoration: 'none',color:'black',textAlign:"center"} }>
<HoverComp  text={"MAP"} img={"https://images.fineartamerica.com/images/artworkimages/mediumlarge/1/our-beautiful-watercolor-world-map-irina-sztukowski.jpg"}/>
</Link>
</Col>

{JSON.parse(localStorage.getItem("user")).category=='m' ?  <Col >
        <Link to="/organizations" relative="path" >
        <HoverComp text={"ORGANIZATIONS"} img={"https://upload.wikimedia.org/wikipedia/commons/d/d0/The_Volunteer_Arms%2C_Union_Street%2C_Bridgwater_-_geograph.org.uk_-_1636544.jpg"}/>
        </Link>
        </Col> : null}
</Row>
    </Container>
    */}
      
    </div>
  )
}

export default Home